<template>
  <div class="ma-2">
    <v-data-table
      :headers="headers"
      :items="itens"
      :options.sync="options"
      :server-items-length="totalItens"
      :loading="loading"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 50, 100],
        showFirstLastPage: true,
        itemsPerPageText: 'Itens por página',
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus'
      }"
      @page-count="pageCount = $event">
        <template v-slot:top>
          <v-form @submit="pesquisar()" v-on:submit.prevent>
            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select clearable v-model="pesquisa.cc_fil" label="Empresa" placeholder="" :items="filiais" item-text="cc_fil" item-value="cc_fil"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="10" lg="10" xl="10">
                  <v-text-field clearable v-model="pesquisa.cc_fin" label="Código" placeholder=""></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                  <v-btn depressed outlined color="primary" type="submit">
                    pesquisar
                  </v-btn>
                </v-col>
              </v-row>            
            </v-container>
          </v-form>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab :color="`${item.bl_est ? 'primary' : ''}`" v-on="on" :disabled="['X'].includes(item.cc_fit)" @click="setarEstornavel(item)" class="mr-1">
                  <v-icon>mdi-undo</v-icon>
                </v-btn>
            </template>
            <span>Estorn&aacute;vel</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab color="primary" v-on="on" :disabled="['D','X'].includes(item.cc_fit)" @click="abrirPlanos(item)" class="mr-1">
                  <v-icon>mdi-numeric-9-plus-circle</v-icon>
                </v-btn>
            </template>
            <span>Planos de pagamento</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab color="primary" v-on="on" :disabled="['D','X'].includes(item.cc_fit)" @click="editar(item)" class="mr-1">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>
            <span>Alterar</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn depressed small fab color="primary" v-on="on" :disabled="['D','X'].includes(item.cc_fit)" @click="deletar(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-card outlined class="mt-2">

        <v-toolbar flat color="accent">
          <v-toolbar-title>Cadastrar/Alterar Finalizadora
            <v-chip
                    v-if="finalizadora.id_reg != undefined"
                    color="primary"
                    close
                    @click:close="resetarFormulario()">
                    {{ finalizadora.cc_fin }}, {{ finalizadora.ds_fin }}
                  </v-chip>
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-form  ref="form" @submit="salvar()" v-model="valid" :lazy-validation="lazy" id="edit-form" v-on:submit.prevent>
            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select item-text="cc_fil" item-value="cc_fil" label="Empresa" :items="filiais" v-model="finalizadora.cc_fil" :rules="validacao.cc_fil" :disabled="disabled"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-text-field label="Código" v-model="finalizadora.cc_fin" :rules="validacao.cc_fin" :disabled="disabled"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select item-text="descricao" item-value="codigo" label="Meio de Pagamento" :items="tiposPagamento" v-model="tipoPagamento" :rules="validacao.cc_fil" :disabled="disabled"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-text-field label="Descrição" v-model="finalizadora.ds_fin" :rules="validacao.nm_psr" :disabled="tipoPagamento !== 'OUTRO'"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
                  <v-select label="Ordenação" :items="ordenacao" v-model="finalizadora.cn_fin" :rules="validacao.cn_fin"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-checkbox v-model="finalizadora.bl_est" label="Estornável"></v-checkbox>
                </v-col>
              </v-row>
              <v-row v-if="this.tipoPagamento === 'OUTRO'">
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select label="Condição" :items="condicoesDePagamento" item-text="descricao" item-value="cc_fin_con" v-model="finalizadora.cc_fin_con" :rules="validacao.cc_fin_con"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                  <v-select prepend-icon="mdi-help-circle" clearable label="Recurso externo" :items="recursosExternos" item-text="ds_rec" item-value="cc_rec" v-model="finalizadora.cc_rec" @click:prepend="abrirAjudaRecursosExternos()"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                  <v-checkbox v-model="finalizadora.bl_par" label="Utiliza parametro" :disabled="finalizadora.cc_rec === undefined"></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn depressed outlined color="primary" type="submit">{{ finalizadora.id_reg != undefined ? 'CONFIRMAR ALTERAÇÕES' : 'CONFIRMAR INSERÇÃO'}}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>

      <pm-ajuda :key="ajuda.key" :modal="ajuda.ativo" :texto='ajuda.texto' v-on:callback="ajuda.ativo = false"></pm-ajuda>
      <pm-plano :finalizadora='plano.finalizadora' :modal='plano.modal' :key="plano.key" v-on:a="plano.modal=false;plano.finalizadora=undefined"></pm-plano>

  </div>
</template>
<script>
  import Ajuda from '../Ajuda.vue'
  import Plano from './Plano.vue'
  import lodash from 'lodash'
  export default {
    name: 'Finalizadora',
    components: {
      'pm-ajuda': Ajuda,
      'pm-plano': Plano,
    },
    data () {
      return {

        /** atributos da paginacao */
        page: 1,
        pageCount: 0,
        itemsPerPage: 5,
        totalItens: 0,
        itens: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Empresa', value: 'cc_fil', sortable:false, width: 80 },
          { text: 'Código', value: 'cc_fin', sortable:false, width: 80 },
          { text: 'Ordem', value: 'cn_fin', sortable:false, width: 60 },
          { text: 'Descrição', value: 'ds_fin', sortable:false },
          { text: '', value: 'action', sortable:false, width: 250, align: 'right' },
        ],

        /** atributos da pesquisa*/
        pesquisa: {
          cc_fil: undefined,
          cc_fin: undefined,
        },

        /** planos de pagamento */
        plano: {
          modal: false,
          finalizadora: undefined,
          key: undefined
        },

        /** propriedades de persistencia*/
        lazy: false,
        valid: true,
        disabled: false,

        filiais:[],
        
        tipoPagamento: undefined,
        ordenacao: [],
        
        ajuda: {
          ativo: false,
          key: 0,
          texto: ''
        },

        finalizadora: {
          id_reg: undefined,
          cc_fil: undefined,
          cc_fin: undefined,
          ds_fin: undefined,
          cn_fin: undefined,
          cc_fit: undefined,
          cc_ger_tef: undefined,
          cc_fin_con: undefined,
          tx_cha_adq: '26359854-5698-1365-9856-965478231456',
          cc_rec: undefined,
          bl_rec: false,
          bl_par: false,
          bl_est: false,
          pc_fin_des: 0.00,
        },

        recursosExternos: [],

        condicoesDePagamento: [
          {
            descricao: 'À vista',
            cc_fin_con: 'V'
          },
          {
            descricao: 'Parcelado',
            cc_fin_con: 'P'
          }
        ],

        tiposPagamento: [
          {
            codigo: 'CT',
            descricao: 'Cartão de Crédito - TEF',
            cc_fit: 'T',
            cc_fin_con: 'P'
          },
          {
            codigo: 'DT',
            descricao: 'Cartão de Débito - TEF',
            cc_fit: 'T',
            cc_fin_con: 'V'
          },
          {
            codigo: 'CP',
            descricao: 'Cartão de Crédito - POS',
            cc_fit: 'P',
            cc_fin_con: 'P'
          },
          {
            codigo: 'DP',
            descricao: 'Cartão de Débito - POS',
            cc_fit: 'P',
            cc_fin_con: 'V'
          },
          {
            codigo: 'CV',
            descricao: 'Cheque',
            cc_fit: 'C',
            cc_fin_con: 'V'
          },
          {
            codigo: 'OUTRO',
            descricao: 'Outros',
            cc_fit: 'O',
            cc_fin_con: undefined
          },
        ],

        validacao: {
          cc_fil:[
            (v) => !!v || 'Requerido',
          ],
          cc_fin:[
            (v) => !!v || 'Requerido',
            (v) => /^[ A-Za-z0-9.\\/-]*$/.test(v) || 'Formato inválido'
          ],
          cc_fin_con: [
            (v) => !!v || 'Requerido',
          ],
          cn_fin: [
            (v) => !!v || 'Requerido',
          ]
        },

      }
    },

    watch: {
      options: {
        handler () {
          this.getDataFromApi()
            .then(data => {
              this.itens = data.items
              this.totalItens = data.total
              this.pageCount = data.totalPages
            })
        },
        deep: true,
      },
      tipoPagamento: {
        handler() {
          this.trataMeioDePagamento()
        }
      },
      'finalizadora.cc_fil': {
        handler() {
          this.obterRecursos()
        }
      },
    },

    mounted () {
      
      this.getDataFromApi()
        .then(data => {
          this.itens = data.items
          this.totalItens = data.total
        })

      this.populaFiliais()

    },

    created: function() {
      this.$vuetify.goTo(0)
      for(let i=2; i<=98; i++) {
        this.ordenacao.push(i);
      }
    },

    computed: {

    },

    methods: {

      editar(obj){

        this.disabled = true
        this.finalizadora = Object.assign({}, obj)

        let tipoPagamento = undefined

        if(this.finalizadora.cc_fit === 'O'){
          tipoPagamento = this.tiposPagamento.filter((el) => { return el.cc_fit === 'O' })[0].codigo
        } else {
          tipoPagamento = this.tiposPagamento.filter((el) => { 
            return (el.cc_fit === this.finalizadora.cc_fit && el.cc_fin_con === this.finalizadora.cc_fin_con) 
          })[0].codigo;
        }

        this.tipoPagamento = tipoPagamento

        this.$vuetify.goTo('#edit-form', {duration: 500,
          offset: 0,
          easing: 'linear',
        })
      },

      deletar(obj) {
        if (confirm('Deseja realmente deletar este registro?')) {
          this.$store.dispatch('deletarFinalizadora', obj.id_reg).then(() => {
            var removeIndex = this.itens.map(function(item) { return item.id_reg; }).indexOf(obj.id_reg);
            if(this.finalizadora.id_reg === this.itens[removeIndex].id_reg){
              this.resetarFormulario()
            }
            this.itens.splice(removeIndex, 1);
          }).catch(err => {
            console.log(err)
          })
        } 
      },

      trataMeioDePagamento() {

        if(this.tipoPagamento != undefined) {
          let tipoPagamentoSelecionado = this.tiposPagamento.filter((el) => { return el.codigo == this.tipoPagamento})[0]
          this.finalizadora.cc_fit = tipoPagamentoSelecionado.cc_fit
          if(this.tipoPagamento !== 'OUTRO') {
            this.finalizadora.cc_fin_con =  tipoPagamentoSelecionado.cc_fin_con
            this.finalizadora.ds_fin = tipoPagamentoSelecionado.descricao
          }
        }
      },

      abrirAjudaRecursosExternos() {
        this.ajuda.ativo = true;
        this.ajuda.key = Math.random() * Math.random()
        this.ajuda.texto = `
          Indica que deve ser feito uma consulta externa (API) sempre 
          que esta finalizadora for utilizada. Ao marcar a opção Utiliza parâmetro, 
          estamos indicando que um dado precisa ser enviado na requisição do recurso externo.`
      },

      obterRecursos() {
        if(this.finalizadora.cc_fil !== undefined) {
          this.recursosExternos = []
          this.$store.dispatch('pesquisaRecurso', {size:999, cc_fil:this.finalizadora.cc_fil}).then( resp => {
            resp.data.content.forEach( el => {
              this.recursosExternos.push(el)
            })
          }).catch( err => {
            console.log(err)
          })
        }
      },

      abrirPlanos(item) {
        this.plano.key = Math.random() * Math.random()
        this.plano.finalizadora = item
        this.plano.modal = true
      },

      setarEstornavel(item){
        this.$store.dispatch('setarFinalizadoraEstornavel', item.id_reg).then(() => {
            item.bl_est = !item.bl_est
          }).catch(err => {
            console.log(err)
          })
      },

      salvar() {

        if (this.$refs.form.validate()) {

          this.finalizadora.cc_rec = (this.finalizadora.cc_rec === undefined) ? '' : this.finalizadora.cc_rec
          //this.finalizadora.bl_rec = (this.finalizadora.cc_rec !== '') ? true : false
          //this.finalizadora.bl_par = (this.finalizadora.bl_par === undefined) ? false : true
          this.finalizadora.tx_cha_adq = (this.finalizadora.tx_cha_adq === undefined) ? '' : this.finalizadora.tx_cha_adq
          this.finalizadora.cc_ger_tef = (this.finalizadora.cc_ger_tef === undefined) ? '' : this.finalizadora.cc_ger_tef
          //this.finalizadora.bl_est = (this.finalizadora.bl_est === undefined) ? false : this.finalizadora.bl_est

          this.$store.dispatch('salvarFinalizadora', this.finalizadora).then(() => {

            if(this.finalizadora.id_reg !== undefined) {
              let item = this.itens.filter((el) => {return el.id_reg === this.finalizadora.id_reg})
              if(item.length > 0){
                Object.assign(this.itens[this.itens.indexOf(item[0])], this.finalizadora)
              }
            }

            this.resetarFormulario()
          }).catch(err => {
            console.log(err)
          })

        }
      },

      resetarFormulario() {
        this.disabled = false
        this.finalizadora.id_reg = undefined
        this.$refs.form.reset()
      },

      pesquisar() {
        this.resetarFormulario()
        this.page = 1
        this.getDataFromApi()
          .then(data => {
            this.itens = data.items
            this.totalItens = data.total
          })
      },

      populaFiliais() {
        this.$store.dispatch('obterFiliais', {}).then(resp => {
          this.filiais = resp.data.content
        }).catch(err => {
          console.log(err)
        })
      },

      getDataFromApi () {

        this.loading = true

        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {

          // eslint-disable-next-line no-unused-vars
          const { sortBy, sortDesc, page, itemsPerPage } = this.options

          let params = {
            page: page-1,
            size: itemsPerPage === -1 ? 999999999 : itemsPerPage,
          };

          let filtro = lodash.omitBy(Object.assign(params, this.pesquisa), o => !o)

          this.$store.dispatch('pesquisaFinalizadora', filtro).then( resp => {

            this.loading = false

            let items        = resp.data.content
            const total      = resp.data.totalElements
            const totalPages = resp.data.totalElements

            resolve( { items, total, totalPages } )

          }).catch( err => {
            console.log(err)
          })

        })
      }
    },
  }
</script>